import axios from 'axios';

import serveradresse_settings from '@/settings/serveradresse_settings.js';
const url = serveradresse_settings.config_server_adresse.url;


export default {
  
  async auswahl_arbeitsanweisungen(credentials) {
    return axios
      .post(url + 'auswahl_arbeitsanweisungen/', credentials)
      .then(response => response.data);
  },

  async zeige_ausgewaehlte_arbeitsanweisung(credentials) {
    return axios
      .post(url + 'zeige_ausgewaehlte_arbeitsanweisung/', credentials)
      .then(response => response.data);
  },

  
  async erzeuge_ausgewaehlte_arbeitsanweisung(credentials) {
    return axios
      .post(url + 'erzeuge_ausgewaehlte_arbeitsanweisung/', credentials)
      .then(response => response.data);
  },

  async update_arbeitsanweisungen(credentials) {
    return axios
      .post(url + 'update_arbeitsanweisungen/', credentials)
      .then(response => response.data);
  },


  async schliesse_arbeitsanweisung_ab(credentials) {
    return axios
      .post(url + 'schliesse_arbeitsanweisung_ab/', credentials)
      .then(response => response.data);
  },

  async loesche_arbeitsanweisung(credentials) {
    return axios
      .post(url + 'loesche_arbeitsanweisung/', credentials)
      .then(response => response.data);
  },

};